import { render, staticRenderFns } from "./activateData.vue?vue&type=template&id=3985aea0"
import script from "./activateData.vue?vue&type=script&lang=js"
export * from "./activateData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports